module.exports = __webpack_public_path__ + "923577aa2d3c4c9e71792d31d879e6a1.svg";